(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('claimsApp')
        .constant('CLAIM_TYPE', {
        	'DEATH': 'Tử vong',
            'TPD': 'Thương tật',
            'CI': 'Bệnh hiểm nghèo',
            'MED': 'Chăm sóc sức khỏe',
        })
})();